export default{
    refunds:{
        titleState:{
            title1:'申请售后',
            title2:'退款明细'
        },
        
        sqsh:{
            shInfo1:'请选择',
            shInfo2:'订单信息',
            shInfo3:'购买数量',
            shInfo4:'操作',
            shInfo5:'订单编号：',
            shInfo6:'规格：',
            shInfo7:'申请退款',
            shInfo8:'已申请退款',
            shInfo9:'申请售后截止时间：',
        },
        tkmx:{
            tkmx1:'服务单号',
            tkmx2:'服务类型',
            tkmx3:'商品名称',
            tkmx4:'退货数量',
            tkmx5:'申退金额',
            tkmx7:'申退总金额',
            tkmx8:'实退总金额',
            tkmx9:'操作',
            tkmx10:'请选择',
            tkmx11:'全部状态',
            tkmx12:'查看',
            tkmx13:'退款明细',
            tkmx14:'含',
            tkmx15:'运费',

        },
        tkmxDialog:{
            tkDialog1:'退款方式：',
            tkDialog2:'原支付方式返回',
            tkDialog3:'应退金额：',
            tkDialog4:'实退金额：',
            tkDialog5:'退款状态：',
            tkDialog6:'退款详情：',
            tkDialog7:'退款金额将原路返回支付账户',
            tkDialog8:'退款可能有延时，请以银行卡或支付账户实际到账时间为准',
            tkDialog9:'确定',
        },
        spfhDialog:{
            spDialog1:'商品寄回使请使用货到付款的方式寄回商品，或与商家协商，平台暂不承担运费补贴！',
            spDialog2:'物流配送',
            spDialog3:'自行配送',
            spDialog4:'快递公司：',
            spDialog5:'请输入2-10位的快递公司名称',
            spDialog6:'快递单号：',
            spDialog7:'请输入8-20位的快递单号',
            spDialog8:'送货人：',
            spDialog9:'请输入送货人姓名',
            spDialog10:'手机号：',
            spDialog11:'请输入送货人手机号',
            spDialog12:'车船号：',
            spDialog13:'请输入车船号',
            spDialog14:'取消',
            spDialog15:'确定',
        },

        rulesInfo:{
            rule1:'请输入快递公司',
            rule2:'请输入快递单号',
            rule3:'请输入送货人姓名',
            rule4:'请输入送货人手机号',
        },
        orderList:{
            ord1:'近三个月订单',
            ord2:'2025年订单',
            ord3:'2024年订单',
            ord4:'2023年订单',
            ord5:'2022年订单'
        }
    }
    
}